import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import CookieConsent from "@/components/CookieConsent";

// Code splitting: rotas internas (admin, mapa/leaflet, documentos) ficam fora
// do bundle inicial — a home carrega só o necessário (LCP/INP).
const NewsPage = lazy(() => import("@/pages/NewsPage"));
const ClergyProfile = lazy(() => import("@/pages/ClergyProfile"));
const PrelacyPage = lazy(() => import("@/pages/PrelacyPage"));
const DocumentsPage = lazy(() => import("@/pages/DocumentsPage"));
const CommunitiesPage = lazy(() => import("@/pages/CommunitiesPage"));
const Admin = lazy(() => import("@/pages/Admin"));
const NotFound = lazy(() => import("@/pages/NotFound"));

function PageLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#FBF9F4]">
      <p className="overline-label text-[#4A0E17]/60">Carregando...</p>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/noticias/:slug" element={<NewsPage />} />
          <Route path="/clero/:slug" element={<ClergyProfile />} />
          <Route path="/prelazias/:slug" element={<PrelacyPage />} />
          <Route path="/documentos" element={<DocumentsPage />} />
          <Route path="/comunidades" element={<CommunitiesPage />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
      <CookieConsent />
    </BrowserRouter>
  );
}

export default App;
